module.exports = __webpack_public_path__ + "static/media/google_market.478b1730.svg";